<template>
  <div>
    <h2 class="title mb-3">
      {{ $t('socialProfiles') }}
      <svg-icon :icon="`pencil`" class="icon-xs ml-2" />
    </h2>
    <b-form>
      <!--      <b-row>-->
      <!-- <b-col sm="6" cols="12">
          <b-form-group label="Native language:" label-for="native-language">
            <input-has-icon>
              <svg-icon icon="translations" />
              <b-form-input
                id="native-language"
                type="text"
                required
                :placeholder="$t('enterLanguage')"
              />
            </input-has-icon>
          </b-form-group>
        </b-col> -->
      <!-- <b-col sm="12" cols="12">
          <b-form-group label="Portfolio link:" label-for="portfolio-link">
            <input-has-icon>
              <svg-icon icon="link" class="text-lighten" />
              <b-form-input
                id="portfolio-link"
                type="text"
                required
                :placeholder="$t('enterLink')"
              />
            </input-has-icon>
          </b-form-group>
        </b-col> -->
      <!--      </b-row>-->
      <!-- <b-form-group>
        <div>
          <label for="facebook" class="d-inline-block col-form-label pt-0">
            Facebook: |
          </label>
          <a
            v-if="!value.facebook"
            href="#"
            class="small"
            @click="connectAccount(form.facebook)"
          >
            {{ $t('connectAccount') }}
          </a>
          <button
            v-else
            style="top: -1px;"
            class="btn btn-link p-0 border-0 position-relative"
            @click="disconnectAccount(form.facebook)"
          >
            <span class="small">{{ $t('disconnectAccount') }}</span>
          </button>
        </div>
        <input-has-icon>
          <svg-icon icon="facebook" class="facebook-color" />
          <b-form-input
            v-if="!value.facebook"
            id="facebook"
            type="text"
            required
            :placeholder="$t('enterLink')"
            v-model="form.facebook"
          />
          <div v-else class="d-inline-block form-control pl-7">
            <a :href="form.facebook" target="_blank">{{ form.facebook }}</a>
          </div>
        </input-has-icon>
      </b-form-group> -->

      <!-- <b-form-group>
        <div>
          <label for="twitter" class="d-inline-block col-form-label pt-0">
            Twitter: |
          </label>
          <a
            v-if="!value.twitter"
            href="#"
            class="small"
            @click="connectAccount(form.twitter)"
          >
            {{ $t('connectAccount') }}
          </a>
          <button
            v-else
            style="top: -1px;"
            class="btn btn-link p-0 border-0 position-relative"
            @click="disconnectAccount(form.twitter)"
          >
            <span class="small">{{ $t('disconnectAccount') }}</span>
          </button>
        </div>
        <input-has-icon>
          <svg-icon icon="twitter" class="twitter-color" />
          <b-form-input
            v-if="!value.twitter"
            id="twitter"
            type="text"
            required
            :placeholder="$t('enterUsername')"
            v-model="form.twitter"
          />
          <div v-else class="d-inline-block form-control pl-7">
            <a :href="form.twitter" target="_blank">{{ form.twitter }}</a>
          </div>
        </input-has-icon>
      </b-form-group> -->
      <b-form-group>
        <b-form-label
          slot="label"
          label="Twitter:"
          for="twitter"
          :errors="errors.twitter"
        />
        <input-has-icon>
          <svg-icon icon="twitter" class="twitter-color" />
          <b-form-input
            id="twitter"
            type="text"
            required
            :placeholder="$t('enterUsername')"
            v-mask="$vMask.twitterMask"
            v-model="form.twitter"
            :state="errors.twitter ? false : null"
          />
        </input-has-icon>
        <span class="small text-light"> {{ $t('example') }}: @jack </span>
      </b-form-group>
      <b-form-group>
        <b-form-label
          slot="label"
          label="Instagram:"
          for="instagram"
          :errors="errors.instagram"
        />
        <input-has-icon>
          <svg-icon icon="instagram" class="instagram-color" />
          <b-form-input
            id="instagram"
            type="text"
            required
            :placeholder="$t('enterUsername')"
            v-mask="$vMask.instagramMask"
            v-model="form.instagram"
            :state="errors.instagram ? false : null"
          />
        </input-has-icon>
        <span class="small text-light"> {{ $t('example') }}: @cristiano </span>
      </b-form-group>
      <b-form-group>
        <b-form-label
          slot="label"
          :label="$t('youtubeChannel') + ':'"
          for="youtube"
          :errors="errors.youtube"
        />
        <input-has-icon>
          <svg-icon icon="youtube" class="youtube-color" />
          <b-form-input
            id="youtube"
            type="text"
            required
            :placeholder="$t('enterLink')"
            v-model="form.youtube"
            :state="errors.youtube ? false : null"
          />
        </input-has-icon>
        <span class="small text-light">
          {{ $t('example') }}:
          https://www.youtube.com/channel/UC5OrDvL9DscpcAstz7JnQGA
        </span>
      </b-form-group>
      <b-form-group>
        <b-form-label slot="label" label="VK:" for="vk" :errors="errors.vk" />
        <input-has-icon>
          <svg-icon icon="vk" class="vk-color" />
          <b-form-input
            id="vk"
            type="text"
            required
            :placeholder="$t('enterLink')"
            v-model="form.vk"
            :state="errors.vk ? false : null"
          />
        </input-has-icon>
        <span class="small text-light">
          {{ $t('example') }}: https://vk.com/durov
        </span>
      </b-form-group>

      <!-- <b-row>
        <b-col sm="6" cols="12">
          <b-form-group
            label="Bitcointalk userinfo:"
            label-for="bitcointalk-userinfo"
          >
            <input-has-icon>
              <svg-icon icon="bitcointalk-alt" class="bitcointalk-color" />
              <b-form-input
                id="bitcointalk-userinfo"
                type="text"
                required
                :placeholder="$t('enterLanguage')"
              />
            </input-has-icon>
          </b-form-group>
        </b-col>
        <b-col sm="6" cols="12">
          <b-form-group label="Profile link:" label-for="profile-link">
            <input-has-icon>
              <svg-icon icon="link" class="text-lighten" />
              <b-form-input
                id="profile-link"
                type="text"
                required
                :placeholder="$t('enterLink')"
              />
            </input-has-icon>
          </b-form-group>
        </b-col>
      </b-row> -->
      <!-- <b-form-group>
        <div>
          <label for="telegram" class="d-inline-block col-form-label pt-0">
            Telegram: |
          </label>
          <a
            v-if="!value.telegram"
            href="#"
            class="small"
            @click="connectAccount(form.telegram)"
          >
            {{ $t('connectAccount') }}
          </a>
          <button
            v-else
            style="top: -1px;"
            class="btn btn-link p-0 border-0 position-relative"
            @click="disconnectAccount(form.telegram)"
          >
            <span class="small">{{ $t('disconnectAccount') }}</span>
          </button>
        </div>
        <input-has-icon>
          <svg-icon icon="telegram" class="telegram-color" />
          <b-form-input
            v-if="!value.telegram"
            id="telegram"
            type="text"
            required
            :placeholder="$t('enterUsername')"
          />
          <div v-else class="d-inline-block form-control pl-7">
            <a :href="form.telegram" target="_blank">{{ form.telegram }}</a>
          </div>
        </input-has-icon>
      </b-form-group> -->
      <!-- <b-form-group label="Reddit:" label-for="reddit">
        <input-has-icon>
          <svg-icon icon="reddit" class="reddit-color" />
          <b-form-input
            id="reddit"
            type="text"
            required
            placeholder="Enter ID"
          />
        </input-has-icon>
      </b-form-group> -->
      <!-- <b-form-group label="Medium:" label-for="medium">
        <input-has-icon>
          <svg-icon icon="medium" class="medium-color" />
          <b-form-input
            id="medium"
            type="text"
            required
            :placeholder="$t('enterLink')"
          />
        </input-has-icon>
      </b-form-group> -->
      <!-- <b-form-group label="Steemit:" label-for="steemit">
        <input-has-icon>
          <svg-icon icon="steemit" class="steemit-color" />
          <b-form-input
            id="steemit"
            type="text"
            required
            :placeholder="$t('enterLink')"
          />
        </input-has-icon>
      </b-form-group> -->
      <!-- <b-form-group label="Blog:" label-for="blog">
        <input-has-icon>
          <svg-icon icon="blog" class="text-lighten" />
          <b-form-input
            id="blog"
            type="text"
            required
            :placeholder="$t('enterLink')"
          />
        </input-has-icon>
      </b-form-group> -->
    </b-form>
  </div>
</template>

<script>
import InputPassword from '@/components/Forms/InputPassword.vue';
import cloneDeep from 'clone';

export default {
  components: {
    InputPassword
  },

  props: {
    value: {
      type: Object,
      default: () => ({
        twitter: null,
        instagram: null,
        youtube: null,
        vkontakte: null
      })
      // required: true
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      form: cloneDeep(this.value)
    };
  },

  methods: {
    connectAccount(acc) {
      alert(`Request for account connection: ${acc}`);
    },
    disconnectAccount(acc) {
      alert(`Request for account disconnection: ${acc}`);
    }
  },

  watch: {
    form: {
      deep: true,
      handler() {
        const emitData = cloneDeep(this.form);
        const usernameFields = ['twitter', 'instagram'];
        Object.keys(emitData).forEach(el => {
          if (!emitData[el]) return;
          if (usernameFields.includes(el)) {
            emitData[el] = emitData[el].replace('@', '').toLowerCase();
          }
        });
        this.$emit('input', emitData);
      }
    }
  }
};
</script>
